import { render, staticRenderFns } from "./ProductsSales.vue?vue&type=template&id=d61003ca&scoped=true&"
import script from "./ProductsSales.vue?vue&type=script&lang=js&"
export * from "./ProductsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61003ca",
  null
  
)

export default component.exports